
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { Subject, takeUntil } from 'rxjs';
import { SearchResourcesDialogComponent } from '../search-resources-dialog/search-resources-dialog.component';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';

@Component({
    selector: 'app-clone-service-data-dialog',
    templateUrl: './clone-service-data-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CloneServiceDataDialogComponent {

    control: FormControl = new FormControl('', Validators.required);

    private _unsubscribeAll = new Subject<void>();



    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            tasksToCancel: string[];
            tasksCantCancel: string[];
        },
        public dialogRef: MatDialogRef<SearchResourcesDialogComponent>,
        private _fuseConfirmationService: FuseConfirmationService,
        private transloco: TranslocoService,
    ) { }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    async saveName(action: string) {
        this.control.markAllAsTouched();
        if (action === 'save') {
            if (!this.control.valid) {
                return;
            }
            const confirmSave = await this.confirm(this.transloco.translate('warning'), this.transloco.translate('saveCloneService'));
            const data = { serviceName: this.control.value };
            if (confirmSave) {
                this.dialogRef.close(data);
            }
        } else if (action === 'cancel') {
            const confirmCancel = await this.confirm(this.transloco.translate('warning'), this.transloco.translate('sendNullReason'));
            if (confirmCancel) {
                this.dialogRef.close();
            }
        }
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    private confirm(title?: string, message?: string, confirm?: string, cancel?: string) {
        const dialogRef = this._fuseConfirmationService.open({
            title: title ? title : this.transloco.translate('unsavedChanges'),
            message: message ? message : this.transloco.translate('exitWithUnsavedChanges'),
            actions: {
                confirm: {
                    label: confirm ? confirm : this.transloco.translate('accept')
                },
                cancel: {
                    label: cancel ? cancel : this.transloco.translate('cancel')
                }
            }
        });

        return new Promise<boolean>((resolve) => {
            dialogRef.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        });
    }
}
